// login
export const STRINGS_LOGIN = "Login";
export const STRINGS_EMAIL = "Email";
export const STRINGS_PASSWORD = "Password";
export const STRINGS_EMAIL_NOT_VALID = "Email not valid";
export const STRINGS_EMAIL_REQUIRED = "Email is required";
export const STRINGS_PASSWORD_REQUIRED = "Password is required";
export const STRINGS_CANCEl = "Cancel";
export const STRINGS_OK = "Ok";
export const STRINGS_PLEASE_FILL_OUT_ALL_INFO = "Please fill out all the info!"
export const STRINGS_PASSWORDS_ARE_NOT_MATCHING = "Passwords are not matching"
export const STRINGS_CHANGE_PASSWORD = "Change Password"
export const STRINGS_INSERT_PASSWORD = "You can insert your new password here"
export const STRINGS_YOU_NEED_TO_LOGIN_AGAIN = "You need to login again"

// home
export const STRINGS_LOGOUT = "Logout";
export const STRINGS_USERS = "Users";
export const STRINGS_ACTIONS = "Actions";
export const STRINGS_TRIVIA = "Trivia";
export const STRINGS_CATEGORIES = "Categories";
export const STRINGS_QUESTIONS = "Questions";
export const STRINGS_ADMIN_PANEL = "Admin Panel";
export const STRINGS_NOTHING_TO_SHOW = "Nothing to show";
export const STRINGS_PACKAGES = "Packages";
export const STRINGS_DISCOUNT_CODES = "Discount Codes";
export const STRINGS_TRANSACTIONS = "Transactions";
export const STRINGS_PAYMENT = "Payment";

// users
export const STRINGS_SEARCH = "Search";
export const STRINGS_USER_MANAGEMENT = "Users Management";
export const STRINGS_MANAGE = "Manage";
export const STRINGS_DETAILS = "Details";
export const STRINGS_CHART = "Chart";
export const STRINGS_JOINED_AT = "Joined";
export const STRINGS_GAMES_LEFT = "Games Left";
export const STRINGS_GAMES_PLAYED = "Games Played";
export const STRINGS_PLAYED_GAMES = "Played Games";
export const STRINGS_GAMES = "Games";
export const STRINGS_TOTAL_SCORE = "Total Score";
export const STRINGS_BIO = "Bio";
export const STRINGS_DATE_OF_LAST_PLAYED = "Date of the Last Played Game";
export const STRINGS_PLAYED_AT = "Played at";
export const STRINGS_SELECTED_CATEGORIES = "Selected Categories";
export const STRINGS_SELECTED_SUBCATEGORIES = "Selected Subcategories";
export const STRINGS_STATS = "Stats";

// trivia
export const STRINGS_CREATE = "Create";
export const STRINGS_FILTER = "Filter";
export const STRINGS_SAVE = "Save";
export const STRINGS_DELETE = "Delete";
export const STRINGS_PREVIEW = "Preview";
export const STRINGS_ADD = "Add";
export const STRINGS_CATEGORY = "Category";
export const STRINGS_SUBCATEGORY = "Subcategory";
export const STRINGS_SUBCATEGORIES = "Subcategories";
export const STRINGS_QUESTION = "Question";
export const STRINGS_ANSWER = "Answer";
export const STRINGS_RATINGS = "Ratings";
export const STRINGS_IMAGE = "Image";
export const STRINGS_TITLE = "Title";
export const STRINGS_EDIT_TITLE = "Edit Title";
export const STRINGS_EDIT_VALUE = "Edit Value";
export const STRINGS_EDIT = "Edit";
export const STRINGS_ATTACHMENT = "Attachment";
export const STRINGS_DIFFICULTY = "Difficulty";
export const STRINGS_UNCERTAINTY = "Uncertainty";
export const STRINGS_LOAD_MORE = "Load More";
export const STRINGS_DELETE_QUESTION = "Delete Question";
export const STRINGS_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_QUESTION = "Are you sure you want to delete the question?";
export const STRINGS_DELETE_PLAYER = "Delete Player";
export const STRINGS_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_PLAYER = "Are you sure you want to delete this player?";
export const STRINGS_DELETE_CATEGORY = "Delete Category";
export const STRINGS_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_CATEGORY = "Are you sure you want to delete the category?";
export const STRINGS_DELETE_PACKAGE = "Delete Package";
export const STRINGS_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_PACKAGE = "Are you sure you want to delete this package?";
export const STRINGS_DELETE_DISCOUNT_CODES = "Delete Discount Code";
export const STRINGS_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_DISCOUNT_CODE = "Are you sure you want to delete this discount code?";
export const STRINGS_NO_RATING_YET = "no rating yet";


export const STRINGS_404_NOT_FOUND = "404 Not Found";
